// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CurrencyInput .CurrencyInput__container div.CurrencyInput__prefix {
  margin-top: 1.15rem;
  margin-right: 0.14rem;
  color: var(--palette-text);
}
`, "",{"version":3,"sources":["webpack://./js/components/library/mui4/input/CurrencyInput/CurrencyInput.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;AAC5B","sourcesContent":[".CurrencyInput .CurrencyInput__container div.CurrencyInput__prefix {\n  margin-top: 1.15rem;\n  margin-right: 0.14rem;\n  color: var(--palette-text);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
